import React from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';

export const UnorderedListOutlined24: React.FC<
  React.PropsWithChildren
> = () => {
  return <UnorderedListOutlined style={{ fontSize: '24px' }} />;
};
